import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Reactions controller connected")
  }

  showReactionPicker(event) {
    console.log("showReactionPicker called", event)
    event.preventDefault()
    event.stopPropagation()

    // Remove any existing picker first
    const existingPicker = document.querySelector('.emoji-picker')
    if (existingPicker) {
      existingPicker.remove()
    }

    const photoId = event.currentTarget.dataset.photoId
    const button = event.currentTarget

    // Common emojis for reactions
    const commonEmojis = ['👍', '❤️', '😂', '😮', '😢', '🎉']

    const picker = document.createElement('div')
    picker.setAttribute('data-controller', 'reactions')
    picker.className = 'emoji-picker fixed bg-white rounded-lg shadow-lg p-2 flex gap-2 z-[100]'
    picker.innerHTML = commonEmojis
      .map(emoji => `
        <button class="hover:bg-gray-100 p-2 rounded transition-colors"
                data-photo-id="${photoId}"
                data-emoji="${emoji}"
                data-action="click->reactions#addReaction">
          ${emoji}
        </button>
      `).join('')

    // Position the picker near the button
    const buttonRect = button.getBoundingClientRect()
    picker.style.left = `${buttonRect.left}px`
    picker.style.top = `${buttonRect.top - 50}px`

    document.body.appendChild(picker)

    // Close picker when clicking outside
    const closeHandler = (e) => {
      if (!picker.contains(e.target) && e.target !== button) {
        picker.remove()
        document.removeEventListener('click', closeHandler)
      }
    }

    // Add click handler after a brief delay
    requestAnimationFrame(() => {
      document.addEventListener('click', closeHandler)
    })
  }

  async addReaction(event) {
    console.log("addReaction called", {
      event,
      photoId: event.currentTarget.dataset.photoId,
      emoji: event.currentTarget.dataset.emoji
    })
    event.preventDefault()
    event.stopPropagation()

    const photoId = event.currentTarget.dataset.photoId
    const emoji = event.currentTarget.dataset.emoji

    try {
      const response = await fetch(`/photos/${photoId}/reactions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ emoji })
      })

      if (response.ok) {
        const data = await response.json()
        this.updateReactionCounts(photoId, data.reactions)

        // Remove the emoji picker after selection
        const picker = document.querySelector('.emoji-picker')
        if (picker) {
          picker.remove()
        }
      }
    } catch (error) {
      console.error('Error adding reaction:', error)
    }
  }

  updateReactionCounts(photoId, reactions) {
    const reactionContainer = document.querySelector(`#photo_${photoId}_reactions .reaction-counts`)
    if (!reactionContainer) return

    reactionContainer.innerHTML = Object.entries(reactions)
      .map(([emoji, count]) => `
        <button class="reaction-button px-2 py-1 text-sm rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white"
                data-photo-id="${photoId}"
                data-emoji="${emoji}"
                data-action="click->reactions#addReaction">
          ${emoji} ${count}
        </button>
      `).join('') + `
        <button class="add-reaction-button px-2 py-1 text-sm rounded-full bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white"
                data-photo-id="${photoId}"
                data-action="click->reactions#showReactionPicker">
          😀+
        </button>
      `
  }

  handleReactionClick(event) {
    event.stopPropagation()
  }
}
